










import Vue, { PropOptions } from 'vue';

export type Code = Blok & {
  sections: Blok[];
};

export default Vue.extend({
  props: {
    blok: {
      type: Object,
      required: true,
    } as PropOptions<Code>,
  },
});
